<template>
  <layout :session="session" :participant="participant">
    <div class="mt-12 sm:mt-0 px-4 py-5 flex flex-col items-center justify-center w-full">
      <div class="min-w-0 flex-1 h-full max-w-sm mx-auto px-3 select-none">
        <img src="/img/participate.png" class="w-3/5 sm:w-4/5 mx-auto my-12" />
      </div>


      <div v-if="session.show_qr_code">
        <div v-html="session.anonymous_access_link_qrcode" class="mt-12 w-3/5 sm:w-64 mx-auto"></div>

        <div class="text-left mt-16 px-5 mx-auto max-w-lg">

          <div class="border-t border-gray-400 mb-4"></div>

          <p v-if="session.introtext" class="font-extralight whitespace-pre-line" v-html="session.introtext"></p>

          <p class="mt-5 font-extralight">Bitte teilen Sie diesen Code mit anderen.</p>
        </div>
      </div>

      <div v-if="!session.show_qr_code">
        <div class="text-left mt-16 px-5 mx-auto max-w-lg">

          <p v-if="session.introtext" class="font-extralight whitespace-pre-line" v-html="session.introtext"></p>
        </div>
      </div>

    </div>
  </layout>
</template>

<script>
import Layout from '@/Pages/Live/Shared/Layout';

export default {
  components: {
    Layout
  },

  props: ['session', 'participant', 'translations'],

  
  mounted() {
    // console.log('intro mounted ' + this.participant.markencode_session.id);
    Echo.channel('markencode-app.session.' + this.participant.markencode_session.id);

    // window.addEventListener("backbutton", this.handleBackButton, false);
  },

  // beforeDestroy () {
  //   window.removeEventListener("backbutton", this.handleBackButton);
  // },

  updated() {
    // console.log('intro updated');
  },

  destroyed() {
    // console.log('leaving intro component');
    // Echo.leave('markencode-app.session.' + this.participant.markencode_session.id);
  },

  data() {
    return {
      sending: false
    };
  },

  methods: {
    // handleBackButton () {
    //   alert("ddd");
    // },
  },
};
</script>